<template>
    <div class="login-form">
        <b-modal
            id="login-modal"
            ref="login-modal"
            title="Ingresar a la sesión"
            :title-class="['h2','text-light']"
            centered
            size="md"
            header-bg-variant="dark"
            header-text-variant="light"
            cancel-title = "Cancelar"
            @hidden="hiddenModal"
            @ok="myCheckin"
            no-close-on-backdrop
            >
              <b-form ref="LoginForm" @submit.stop.prevent id="LoginForm">
                <fieldset :disabled="formDisabled">
                  <b-form-row>
                    <b-col cols="12" class="text-right" v-if="selector">
                      <b-form-checkbox v-model="login_license" name="check-button" button-variant="primary" button>
                        {{login_license?'Usar mi correo':'Usar mi cédula Profesional'}}
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="12" v-if="!login_license">
                      <b-form-group
                        :state="emailError?false:true"
                        label-for="email"
                        label-class="text-left"
                        :invalid-feedback="emailError"
                        label="Ingresar usando Email"
                      >
                        <b-input-group class="mb-2">
                          <b-form-input
                            aria-label="Email"
                            id="email"
                            placeholder="Email"
                            v-model="thing.email"
                            :state="emailError?false:true"
                            trim
                          ></b-form-input>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox class="mr-n2" v-model="remember_me">
                              <small>Recordarme</small>
                            </b-form-checkbox>
                          </b-input-group-prepend>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-else>
                      <b-form-group
                        :state="licenseError?false:true"
                        label-for="license"
                        label-class="text-left"
                        :invalid-feedback="licenseError"
                        label="Ingresar usando cédula profesional"
                      >
                      <b-input-group class="mb-2">
                          <b-form-input
                            aria-label="Cédula profesional"
                            id="license"
                            placeholder="Cédula profesional"
                            v-model="thing.license"
                            :state="licenseError?false:true"
                            trim
                          ></b-form-input>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox class="mr-n2" v-model="remember_me">
                              <small>Recordarme</small>
                            </b-form-checkbox>
                          </b-input-group-prepend>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-if="pending_validationError">
                      <h3 class="text-danger text-center">{{this.pending_validationError}}</h3>
                    </b-col>
                    <b-col sm="12">
                      <b-form-group
                        label="Para aceptar las condiciones debe 'marcar' la siguiente casilla."
                        label-size="sm"
                        label-class="text-primary"
                        >
                        <b-form-checkbox size="" class="text-justify" v-model="accept">
                          <p class="text-dark font-alt">
                            Acepto
                          </p>
                          <!-- <p class="privacy text-dark">
                            Clave Interna 1506MX21PR00202
                          </p> -->
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                </fieldset>
                <h3 v-if="no_exist" class="text-danger text-center">{{no_exist}} No encontrado</h3>
              </b-form>
              <template v-slot:modal-footer>
                <b-button-group class="float-right" size="md">
                  <b-button v-if="!formDisabled && accept" @click="myCheckin" variant="danger">
                    Validar
                  </b-button>
                </b-button-group>
              </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'LoginForm',
    props: {
      eventKeyId: { type: String, default: null },
      use_license: { type: Boolean, default: false },
      selector: { type: Boolean, default: true },
    },
    data() {
        return {
          thing: {
            email: null,
            id: null,
            url: null,
            name: null,
            phone: null,
            city: null,
            specialty: null,
            license: null,
            name: null,
            last_name: null,
            mother_last_name: null,
            event__url_to: null,
            event__name: null,
            event__start_date: null,
            key_id: null,
            event_key_id: null,
            join_url: null,
            federal_entity: null,
            country: null,
            company: null,
            position: null,
            confirmed: false,
            browser_info: this.$browserDetect.meta.ua,
            site: null,
          },
          formDisabled: false,
          errors: [],
          no_exist: null,
          accept:false,
          login_license : this.use_license,
          remember_me: true
        }
    },
    methods: {
      showModal() {
        this.$bvModal.show('login-modal')
      },
      hiddenModal(msg) {
        if(msg) this.$emit('closed', msg)
        else this.$emit('closed')
      },
      myCheckin() {
        let loader = this.$loading.show()
        this.thing.event_key_id= this.eventKeyId
        this.errors = []
        this.formDisabled = true
        let url = '/assistants/my_check_in'
        if(this.login_license) url = '/assistants/login_with_license'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: this.thing, headers:{}})
          .then((resp) => {
            loader.hide()
            let active_word_clouds = resp.data.active_word_clouds
            active_word_clouds.forEach(element => {
                if(element.json_options) element.json_options = JSON.parse(element.json_options)
            });
            this.thing = resp.data
            this.$store.commit(
              'auth_success', 
              {
                'token': this.thing.key_id,
                'assistant': {
                  'name': this.thing.name + ' ' + this.thing.last_name + ' ' + this.thing.mother_last_name,
                  'email': this.thing.email,
                  'nickname': this.thing.nickname,
                  'id': this.thing.id,
                  'key_id': this.thing.key_id,
                  'remaining_attempts': this.thing.remaining_attempts,
                  'exam_approved': this.thing.exam_approved,
                  'answered_survey': this.thing.answered_survey,
                  'session_id': this.thing.session_id,
                  'join_url': this.thing.join_url,
                  //'active_word_clouds':active_word_clouds
                },
                'email': this.thing.email,
                'remember_me': this.remember_me
              }
            )
            
            if(this.thing.join_url) this.$store.commit('set_url_to', this.thing.join_url)
            else this.$store.commit('set_url_to', this.event.url_to)
            
            this.$nextTick(() => {
              this.$store.commit('set_data_poll', resp.data.poll_data)
              this.$store.commit('set_data_rating', resp.data.pending_ratings)
              this.$store.commit('set_data_word_cloud', active_word_clouds)
              this.redirect()
            })
          })
          .catch(err => {
            loader.hide()
            this.formDisabled = false
            this.errors = err.errors
            if(this.pending_validationError) {
              this.no_exist = false
            } else this.no_exist = this.login_license?this.thing.license:this.thing.email
            if(this.login_license && err.data)
            {
              if(!this.pending_validationError)
                this.$emit('signUp', err.data)
            }
            if(!this.login_license) {
              if(!this.pending_validationError)
                this.$emit('signUp', this.thing.email)
            }
          })
      },
      redirect() {
        if(this.$route.name != 'OnSite') {
          if(this.event.demo_mode) {
            this.hiddenModal({
              'text': 'Por favor verifique que el audio este activado, en la pantalla de video, abajo a la izquierda, para poder escuchar la conferencia, Gracias.',
              'title': 'Direccionando....'
            })
          } else
            this.hiddenModal({
              'text': 'Gracias por registrarse. Bienvenido.',
              'title': ' '
            })
        } else {
          this.hiddenModal()
        }
      },
    },
    beforeMount() {
      
      this.thing.site = this.$store.getters.site_location
    },
    mounted() {
      this.$store.getters.event
      this.showModal()
    },
    computed: {
      emailError: function () {
        if(this.errors && this.errors.email) return this.errors.email[0]
        return null
      },
      pending_validationError: function () {
        if(this.errors && this.errors.pending_validation) return this.errors.pending_validation[0]
        return null
      },
      licenseError: function () {
        if(this.errors && this.errors.license) return this.errors.license[0]
        return null
      },
      event() {
        return this.$store.getters.event
      },
    },
})
</script>

<style lang="scss" scoped>
  @import '../../styles/app';

  #login-form {
  }

  p.privacy {
    line-height: 0.75rem !important;
    font-size: .7rem !important;
    font-weight: lighter !important;
  }
</style>
